import './Content.less'
import './MaintenanceWarning.less'

import React, { Component } from 'react'
import { translate } from 'react-i18next'

import { Footer } from '../Footer/Footer'
/* import ProgressiveBackgroundImage from './ProgressiveBackgroundImage/ProgressiveBackgroundImage' */

class Content extends Component {
  render() {
    const t = this.props.t

    return (
      <section className="content">
        {/* <ProgressiveBackgroundImage /> */}
        <section className="top_cover" />

        {!this.props.noContentWrapper ? (
          <div className="container">
            {/* <div className="maintenance-warning">{t("maintenanceWarning")}</div> */}
            <div className="row">
              <div className="col-md-6 order-md-2 marketing">
                <h1>{t('marketingTitle')}</h1>
                {/* <p>{t("marketingMessage")}</p> */}
              </div>
              <div className="col-md-6">
                <div className="content-container">{this.props.children}</div>
              </div>
            </div>
            <Footer />
          </div>
        ) : (
          this.props.children
        )}
      </section>
    )
  }
}

const translateContent = translate('landingpage')(Content)

export { translateContent as Content }



// WEBPACK FOOTER //
// ./src/components/Content/Content.js